/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Container, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { useContext } from 'react';
import ListNews from '../../../components/ListNews';
import { useLoading } from '../../../providers/LoadingProvider';
import { UserContext } from '../../../providers/UserProvider';
import { getNews } from '../../../services/news';
import { isBibiUser } from '../../../utils/roles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 'inherit',
  },
  container: {
    paddingLeft: 0,
    paddingRight: 0,
    justifyContent: 'center',
  },
  title: {
    fontSize: 36,
    color: '#FFFFFF',
    textTransform: 'uppercase',
    letterSpacing: '-2.05px',
  },
  orangeSet: {
    backgroundColor: '#FE5D00',
    padding: '0rem 0rem 5rem 0rem',
  },
  whiteSet: {
    backgroundColor: '#FFFFFF',
    height: 0,
  },
  mainCards: {
    marginTop: '40px',
  },
}));

export default function News() {
  const { userState } = useContext(UserContext);
  const [news, setNews] = useState([]);
  const classes = useStyles();
  const { setLoading } = useLoading();

  let canAddNews = false;

  if (
    userState?.tipo === 'BA' ||
    (userState?.tipo === 'B' && userState?.permissoes?.includes('NO'))
  ) {
    canAddNews = true;
  }

  useEffect(() => {
    const request = async () => {
      setLoading(true);
      const response = await getNews();
      setNews(response);
      setLoading(false);
    };

    request();
  }, []);

  return (
    <div className={classes.root}>
      <Container component="main" className={classes.container}>
        <Box
          className={clsx(`${classes.orangeSet} `, {
            fit: isBibiUser(userState?.tipo),
          })}
          textAlign="center"
        >
          <Box paddingTop={2} textAlign="center" className="header-div">
            <Typography
              className={classes.title}
              component="h1"
              variant="subtitle1"
            >
              Noticias
            </Typography>
          </Box>
        </Box>
        <Box className={`header-div ${classes.whiteSet}`}>
          <Box className={`${classes.mainCards}`}>
            <Grid
              container
              spacing={4}
              justify="flex-start"
              alignItems="flex-start"
            >
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <ListNews news={news} addNews={canAddNews} />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </div>
  );
}
